import {useMemo} from "react";

import {PRICING_FEATURE_PROPERTIES_ARRAY} from "./pricingFeatureProperties";
import {featureHasSelectedFilters} from "../../FeatureCreator/FeaturesFilters/filtersFunctions";

const S3_THUMBNAIL_URL = "https://s3.amazonaws.com/features-thumbnails/feature-";

export const getFeatureThumbnail = (imageKey) => {
  return S3_THUMBNAIL_URL + imageKey + ".png"
}

export const getFeaturePropertiesGridColumnStyles = (columns) => {
  let columnStyles = "";
  {PRICING_FEATURE_PROPERTIES_ARRAY.forEach(property => {
    if (!columns.includes(property)) {
      return
    }
    switch (property) {
      case "index":
      case "checkbox":
        columnStyles += "minmax(44px, 44px)";
        break;
      case "name":
      case "sharedFeatureName":
        columnStyles += " minmax(44px, 1fr)";
        break;
      case "sku":
        columnStyles += " minmax(44px, 160px)";
        break;
      case "description":
        columnStyles += " minmax(44px, 1.5fr)";
        break;
      case "price":
      case "cost":
      case "fabricatorCost":
      case "thumbnail":
      default:
        columnStyles += " minmax(44px, 100px)";
        break;
      // default:
      //   columnStyles += " minmax(44px, min-content)";
      //   break;
    }
  })}
  return {
    "gridTemplateColumns": columnStyles
  }
}

/**
 * returns the same list for several features-setup components
 * @param pricingFeaturesList {pricingFeatureInterface[]}
 * @param pricingFeaturesReceived {boolean}
 * @param pricingSearchText {string}
 * @param selectedFilters {array}
 * @param selectedOnly {boolean}
 * @return {pricingFeatureInterface[]}
 */
export const useGetPricingFilteredFeatures = (pricingFeaturesList = [],
                                              pricingFeaturesReceived = false,
                                              pricingSearchText = "",
                                              selectedFilters= [],
                                              selectedOnly = false) => {
  // console.log("recalculate features", );
  return useMemo(() => {
    if (!pricingFeaturesReceived) {
      return []
    }
    const lowerCasedSearchText = pricingSearchText ? pricingSearchText.toLowerCase() : "";
    return pricingFeaturesList.filter(feature => {
      if (lowerCasedSearchText && (!feature.displayName || !feature.displayName.toLowerCase().includes(lowerCasedSearchText))) {
        return false
      }
      if (selectedOnly && !feature.selected) {
        return false
      }
      if (selectedFilters.length && !featureHasSelectedFilters(feature, selectedFilters)) {
        return false
      }
      return true
    })
  }, [pricingSearchText, pricingFeaturesList, pricingFeaturesReceived, selectedFilters, selectedOnly])
}

// /**
//  * returns the same list for several price list components
//  * @param store {object}
//  * @param withFilters {boolean}
//  * @param selectedOnly {boolean}
//  * @return {pricingFeatureInterface[]}
//  */
// export const getFilteredPricingFeatures = (store, withFilters = true, selectedOnly = false) => {
//   const {pricingFeaturesList, pricingSearchText, pricingFeaturesReceived} = store.pricingState;
//   if (!pricingFeaturesReceived) {
//     return []
//   }
//   console.log("getFilteredPricingFeatures", );
//   const {selectedFilters} = store.featuresFiltersState;
//   const lowerCasedSearchText = pricingSearchText ? pricingSearchText.toLowerCase() : "";
//   return pricingFeaturesList.filter(feature => {
//     if (lowerCasedSearchText && (!feature.displayName || !feature.displayName.toLowerCase().includes(lowerCasedSearchText))) {
//       return false
//     }
//     if (selectedOnly && !feature.selected) {
//       return false
//     }
//     if (selectedFilters.length && !featureHasSelectedFilters(feature, selectedFilters)) {
//       return false
//     }
//     return true
//   })
// }

export const featureIsEditedAndCanBeSaved = (editeFeatureObject) => {
  if (!editeFeatureObject.fabricatorFeatureIds) {
    return false
  }
  return Object.keys(editeFeatureObject).some(prop => {
    return prop !== "fabricatorFeatureIds"
  })
}
